export const articlesAnalysisLevels = [
  {
    slug: 'how-to-find-support-resistance',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีหาแนวรับแนวต้านบนกราฟ Forex',
    description:
      'ขั้นตอนการหาโซนแนวรับแนวต้านจากจุดที่ราคาเคยหยุดจริง พร้อมวิธีจัดลำดับความสำคัญของแต่ละโซน',
    readingTime: '7 นาที',
    updatedDate: '2026-10-14',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20horizontal%20support%20and%20resistance%20zones%20marked%20over%20teal%20candlestick%20chart%20clean%20light%20background%20warm%20orange%20bands%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-find-support-resistance-01&orientation=landscape',
    tags: ['แนวรับแนวต้าน', 'อ่านกราฟ', 'โซนราคา'],
    intro: [
      'แนวรับแนวต้านไม่ใช่เส้นที่วาดขึ้นมาจากตัวเลข แต่มาจากจุดที่ราคาเคยหยุด ถูกปฏิเสธ หรือกลับตัวจริง',
      'การหาโซนที่ถูกต้องทำให้จุดเข้าและจุดผิดมีความหมายขึ้น เพราะอ้างอิงจากพฤติกรรมตลาดเดิม',
    ],
    sections: [
      {
        id: 'mark',
        heading: 'เริ่มจากจุดที่ราคาเคยถูกปฏิเสธ',
        paragraphs: [
          'กวาดตาหาจุดที่ราคาแตะแล้วเด้งกลับอย่างชัดเจน ถ้าจุดเดิมถูกแตะซ้ำหลายครั้งและราคาตอบสนองทันที นั่นคือโซนที่มีนัย',
        ],
        bullets: ['โซนที่ถูกแตะอย่างน้อยสองครั้งมีความหมายกว่าจุดเดี่ยว', 'บันทึกว่าจุดนั้นเป็นแนวรับหรือแนวต้าน', 'หลีกเลี่ยงการวาดทุกยอดเล็ก ๆ'],
        steps: [],
      },
      {
        id: 'zone',
        heading: 'วาดเป็นโซน ไม่ใช่เส้น',
        paragraphs: [
          'ราคาไม่เคยเคารพตัวเลขจุดทศนิยม การวาดเป็นแถบกว้างเล็กน้อยครอบคลุมไส้ของแท่งที่ถูกปฏิเสธจะใช้งานได้จริงกว่า',
        ],
        bullets: ['ความกว้างของโซนขึ้นกับกรอบเวลา', 'โซนบนกรอบใหญ่กว้างกว่าเสมอ', 'ถ้าโซนกว้างเกินไปให้ลดกรอบเวลาลง'],
        steps: [],
      },
      {
        id: 'rank',
        heading: 'จัดลำดับความสำคัญ',
        paragraphs: [
          'ไม่ใช่ทุกโซนมีน้ำหนักเท่ากัน ดูจากจำนวนครั้งที่ถูกทดสอบ กรอบเวลาที่โซนนั้นอยู่ และความชัดเจนของการตอบสนองของราคา',
          'เกณฑ์ที่ใช้ง่ายคือโซนที่ถูกทดสอบไปแล้ว 3 ถึง 4 ครั้งจะเริ่มอ่อนแรง เพราะทุกรอบที่ราคาแตะ โซนนั้นจะถูกใช้คำสั่งไปบ้าง โซนบน D1 มีน้ำหนักกว่าโซนบน M15 ประมาณ 2 ถึง 3 เท่า และถ้าราคาเคยเด้งออกจากโซนนั้นเกิน 40 Pip อย่างชัดเจน ถือว่าโซนนั้นมีความสำคัญ',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ควรวาดแนวรับแนวต้านกี่เส้น',
        a: 'ไม่ควรเกินสองถึงสามโซนในแต่ละฝั่ง ถ้ามีมากกว่านั้นแปลว่ากำลังวาดโซนที่ไม่สำคัญและจะทำให้ตัดสินใจยาก',
        a2: 'ตัวเลขที่ช่วยได้คือ ในกราฟ H4 ย้อนหลัง 3-6 เดือน มักเหลือโซนที่ราคาเคยตอบสนองจริงเพียง 2-3 โซนต่อฝั่ง ถ้าวาดได้ 6-8 เส้นแปลว่ากำลังให้ความสำคัญกับทุกแท่งที่เคยหยุด ซึ่งจะทำให้ไม่เหลือพื้นที่ให้ตัดสินใจ',
      },
      {
        q: 'แนวรับจากกรอบเล็กใช้ได้ไหม',
        a: 'ใช้ได้แต่มีน้ำหนักน้อย ควรเริ่มจากกรอบใหญ่ก่อนเสมอ แล้วค่อยใช้กรอบเล็กหาจุดละเอียดภายในโซนนั้น',
        a2: 'ตัวอย่างที่ชัดคือ แนวรับบน H1 ที่อยู่ในโซนแนวรับ D1 มีน้ำหนักมากกว่าแนวรับ H1 ที่ลอยอยู่คนเดียว ถ้าโซนจากกรอบใหญ่กับกรอบเล็กซ้อนกันภายใน 10-15 Pip ให้ถือว่าเป็นโซนเดียวกันและใช้โซนใหญ่เป็นหลัก',
      },
    ],
    related: ['support-resistance', 'dynamic-support-resistance', 'support-resistance-breakout'],
  },
  {
    slug: 'dynamic-support-resistance',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'แนวรับแนวต้านแบบไดนามิกคืออะไร',
    description:
      'รู้จักแนวรับแนวต้านที่เคลื่อนที่ตามราคา อย่างเส้นค่าเฉลี่ยและเส้นแนวโน้ม พร้อมข้อจำกัดที่ต้องเข้าใจก่อนใช้',
    readingTime: '6 นาที',
    updatedDate: '2026-10-13',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20sloped%20dynamic%20support%20line%20following%20price%20curve%20teal%20chart%20clean%20light%20background%20warm%20orange%20curve%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-dynamic-support-resistance-01&orientation=landscape',
    tags: ['แนวรับแนวต้าน', 'เส้นแนวโน้ม', 'Moving Average'],
    intro: [
      'แนวรับแนวต้านแบบไดนามิกคือระดับที่ขยับตามราคา ไม่ได้อยู่กับที่เหมือนเส้นแนวนอน',
      'ตัวอย่างที่พบบ่อยคือเส้นค่าเฉลี่ยเคลื่อนที่และเส้นแนวโน้ม ซึ่งทำหน้าที่คล้ายแนวรับหรือแนวต้านระหว่างที่ตลาดเคลื่อนไหว',
    ],
    sections: [
      {
        id: 'types',
        heading: 'มีอะไรบ้าง',
        paragraphs: [
          'เส้นค่าเฉลี่ยเคลื่อนที่ให้แนวรับแนวต้านที่ไล่ตามราคา ส่วนเส้นแนวโน้มให้แนวรับในขาขึ้นหรือแนวต้านในขาลง',
        ],
        bullets: ['Moving Average = แนวรับแนวต้านที่ปรับตามค่าเฉลี่ย', 'เส้นแนวโน้ม = แนวรับในขาขึ้นหรือแนวต้านในขาลง', 'ไม่ใช่ทุกการแตะที่จะทำให้ราคาเด้งกลับ'],
        steps: [],
      },
      {
        id: 'limit',
        heading: 'ข้อจำกัดที่ต้องรู้',
        paragraphs: [
          'แนวรับแนวต้านแบบไดนามิกขึ้นกับสูตรคำนวณ จึงไม่ใช่ระดับที่ตลาดให้ความสำคัญโดยธรรมชาติ ในตลาดแกว่งตัวแรง ราคาอาจผ่านเส้นไปโดยไม่ตอบสนองเลย',
        ],
        bullets: ['ใช้เป็นตัวช่วย ไม่ใช่จุดตัดสินใจเดียว', 'ตรวจบริบทด้วยโซนแนวนอนเสมอ', 'ยิ่งเส้นยาว ยิ่งตอบสนองช้า'],
        steps: [],
      },
      {
        id: 'combine',
        heading: 'ใช้ร่วมกับโซนแนวนอน',
        paragraphs: [
          'จุดที่มีทั้งโซนแนวนอนและแนวรับแนวต้านแบบไดนามิกซ้อนกัน มักเป็นบริเวณที่ราคาตอบสนองชัดกว่า แต่ก็ไม่ได้หมายความว่าจะเด้งทุกครั้ง',
          'เช่น ถ้า EMA 50 บน H4 อยู่ที่ 1.0850 และมีแนวรับแนวนอนเดิมที่ 1.0845 ถึง 1.0852 ให้ถือว่าเป็นโซนเดียว ไม่ใช่สองโซนแยกกัน การรวมโซนจะทำให้ Stop Loss สั้นลงเหลือ 15 ถึง 20 Pip แทนที่จะเป็น 40 Pip และอัตราส่วน Risk ต่อ Reward ดีขึ้นทันทีโดยไม่ต้องเพิ่มความเสี่ยง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'แนวรับแนวต้านแบบไดนามิกแม่นกว่าแบบแนวนอนไหม',
        a: 'ไม่ใช่ แบบแนวนอนสะท้อนพฤติกรรมตลาดจริง ส่วนแบบไดนามิกเป็นเครื่องช่วยอ่าน ควรใช้คู่กันมากกว่าเปรียบกัน',
        a2: 'ข้อจำกัดที่ควรรู้คือ เส้นค่าเฉลี่ยลากตามราคา จึงไม่เคยหยุดราคาได้แม่นยำเหมือนระดับแนวนอน ในตลาดไซด์เวย์เส้นจะถูกตัดผ่าน 5-10 ครั้งต่อสัปดาห์จนไม่เหลือความหมาย ควรใช้เป็นตัวช่วยดูทิศทางเท่านั้น',
      },
      {
        q: 'ต้องใช้เส้นค่าเฉลี่ยระยะไหน',
        a: 'เลือกตามกรอบเวลาที่ใช้งาน เช่นระยะ 20 หรือ 50 สำหรับกรอบกลาง และระยะยาวสำหรับดูภาพรวม ไม่จำเป็นต้องมีหลายเส้น',
        a2: 'ตัวเลขที่ใช้ได้คือ EMA 20 สำหรับจังหวะสั้น EMA 50 สำหรับแนวโน้มกลาง และ EMA 200 สำหรับภาพรวม ถ้าใส่ทั้งสามเส้นพร้อมกัน ให้ใช้เพียงเส้นเดียวกำหนดทิศและอีกเส้นเป็นแนวรับเคลื่อนที่ ไม่ต้องใช้ทุกเส้นตัดสินใจพร้อมกัน',
      },
    ],
    related: ['support-resistance', 'moving-average-indicator', 'how-to-find-support-resistance'],
  },
  {
    slug: 'support-resistance-breakout',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'การทะลุแนวรับแนวต้านหมายถึงอะไร',
    description:
      'เข้าใจว่าการเบรกแนวรับแนวต้านบอกอะไร วิธีรอยืนยัน และเหตุผลที่ระดับเดิมมักกลายเป็นแนวตรงข้ามหลังถูกเบรก',
    readingTime: '7 นาที',
    updatedDate: '2026-10-12',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20resistance%20breakout%20chart%20illustration%20teal%20candles%20crossing%20warm%20orange%20horizontal%20level%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-support-resistance-breakout-01&orientation=landscape',
    tags: ['ทะลุแนว', 'แนวรับแนวต้าน', 'ยืนยัน'],
    intro: [
      'การทะลุแนวรับแนวต้านคือการที่ราคาเคลื่อนผ่านโซนที่เคยหยุดไว้ได้ ซึ่งบ่งชี้ว่าสมดุลเดิมของตลาดกำลังเปลี่ยน',
      'แต่การทะลุที่แท้จริงกับการทะลุหลอกหน้าตาแทบเหมือนกันตอนเกิดขึ้น จึงต้องมีเกณฑ์ยืนยัน',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'การทะลุบอกอะไร',
        paragraphs: [
          'เมื่อแนวต้านถูกเบรกอย่างชัดเจน ฝั่งซื้อได้เปรียบขึ้นในบริเวณนั้น และระดับที่เคยเป็นแนวต้านมักกลายเป็นแนวรับในการย้อนกลับครั้งถัดไป',
        ],
        bullets: ['ระดับเดิมสลับบทบาทได้', 'การทะลุด้วยแท่งใหญ่บ่อยครั้งมีแรงตามมา', 'ควรบันทึกว่าโซนถูกเบรกไปแล้ว'],
        steps: [],
      },
      {
        id: 'confirm',
        heading: 'เกณฑ์ยืนยันเบื้องต้น',
        paragraphs: [
          'อย่างน้อยควรรอแท่งปิดพ้นโซน ไม่ใช่เพียงไส้ที่แทงผ่าน และดูว่ามีแรงซื้อหรือแรงขายตามมาหลังการปิดหรือไม่',
        ],
        bullets: ['รอแท่งปิดพ้นโซน', 'ดูว่าราคากลับไปยืนเหนือโซนเดิมได้หรือไม่', 'ระวังการทะลุช่วงข่าว'],
        steps: [],
      },
      {
        id: 'risk',
        heading: 'ความเสี่ยงที่ต้องยอมรับ',
        paragraphs: [
          'ตลาดเบรกแนวเพื่อล่อแล้วกลับตัวบ่อยมาก การตั้งจุดผิดไว้ใกล้ ๆ โซนเดิมคือสิ่งที่ทำให้ความเสียหายจำกัดเมื่อคาดการณ์ผิด',
          'สถิติที่ควรรู้คือบน M15 การเบรกแล้วกลับตัวภายใน 3 แท่งเกิดขึ้นบ่อยในสัดส่วนที่สูงกว่ากรอบ H4 อย่างชัดเจน จึงควรตั้ง Stop Loss ไว้อีกฝั่งของโซน 5 ถึง 10 Pip ไม่ใช่ชิดขอบโซน เพราะการวางชิดทำให้ถูกกวาดออกด้วยไส้เทียนก่อนที่ราคาจะไปทางที่เราคิด' ,
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้องรอกี่แท่งหลังทะลุ',
        a: 'ไม่มีตัวเลขตายตัว ขึ้นกับกรอบเวลา บางคนรอหนึ่งแท่งปิด บางคนรอการย้อนกลับมาแตะโซนเดิม สิ่งสำคัญคือเกณฑ์ต้องชัดและใช้เหมือนเดิมทุกครั้ง',
        a2: 'ตัวเลขที่ใช้กันคือ รอ 1-2 แท่งปิดพ้นโซนอย่างน้อย 10 Pip สำหรับคู่เงินหลัก และควรเห็นแท่งปิดอยู่เหนือระดับนั้นจริง ไม่ใช่แค่ไส้แท่งทะลุ ถ้าเลือกเกณฑ์ไหนแล้ว ให้ใช้เกณฑ์เดิมอย่างน้อย 30 ไม้ก่อนประเมินผล',
      },
      {
        q: 'ทะลุแล้วราคากลับมาได้ไหม',
        a: 'ได้บ่อยมาก นี่คือการทะลุหลอก ซึ่งเป็นเหตุผลที่ต้องกำหนดจุดผิดและขนาดความเสี่ยงไว้ล่วงหน้าเสมอ',
        a2: 'ตัวเลขที่ควรรู้คือ การทะลุหลอกเกิดบ่อยราว 4-6 ใน 10 ครั้งบนกรอบ M15 และลดลงเหลือ 2-3 ใน 10 ครั้งบน H4 นี่คือเหตุผลที่ควรใช้กรอบใหญ่กรอง และรอการย้อนกลับมาแตะโซนเดิมก่อนเข้า',
      },
    ],
    related: ['support-resistance', 'false-breakout', 'how-to-find-support-resistance'],
  },
  {
    slug: 'false-breakout',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีสังเกตการทะลุหลอกของราคา',
    description:
      'สัญญาณที่บอกว่าราคาเพิ่งทะลุแนวแต่มีโอกาสกลับเข้ามาในกรอบ พร้อมวิธีลดความเสียหายจากการทะลุหลอก',
    readingTime: '7 นาที',
    updatedDate: '2026-10-11',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20false%20breakout%20chart%20trap%20illustration%20teal%20candle%20spike%20beyond%20warm%20orange%20level%20then%20returning%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-false-breakout-01&orientation=landscape',
    tags: ['ทะลุหลอก', 'แนวรับแนวต้าน', 'ความเสี่ยง'],
    intro: [
      'การทะลุหลอกคือการที่ราคาเคลื่อนผ่านแนวสำคัญแล้วกลับเข้ามาในกรอบเดิมอย่างรวดเร็ว ทิ้งคนที่เข้าเร็วไว้ผิดทาง',
      'มันไม่ใช่ความผิดพลาดของกราฟ แต่เป็นพฤติกรรมปกติของตลาดที่ต้องคาดไว้',
    ],
    sections: [
      {
        id: 'signs',
        heading: 'สัญญาณที่มักเห็น',
        paragraphs: [
          'แท่งที่ทะลุมีไส้ยาวแต่ตัวแท่งสั้น หรือราคาแทงผ่านแล้วปิดกลับเข้าในโซนเดิมภายในแท่งเดียวกัน บ่อยครั้งเกิดในช่วงสภาพคล่องต่ำ',
        ],
        bullets: ['ไส้แทงพ้นโซนแต่ปิดกลับในโซน', 'แท่งทะลุมีขนาดเล็กผิดปกติ', 'เกิดในช่วงตลาดเปิดใหม่หรือปิดสัปดาห์'],
        steps: [],
      },
      {
        id: 'check',
        heading: 'วิธีตรวจก่อนเชื่อ',
        paragraphs: [
          'ดูกรอบเวลาที่ใหญ่กว่า ถ้ากรอบใหญ่ยังไม่ผ่านโซนเดียวกัน นั่นคือความขัดแย้งที่ควรทำให้ระวัง และควรหลีกเลี่ยงการเข้าในจังหวะที่ราคาอยู่ห่างจากโซนอื่นมาก',
        ],
        bullets: ['ตรวจกรอบใหญ่ทุกครั้ง', 'หลีกเลี่ยงการเข้าตอนราคาเหวี่ยงจากข่าว', 'รอการย้อนกลับมายืนทดสอบโซน'],
        steps: [],
      },
      {
        id: 'manage',
        heading: 'ลดความเสียหายอย่างไร',
        paragraphs: [
          'กำหนดจุดผิดให้อยู่คนละฝั่งของโซน ไม่ใช่กลางโซน และลดขนาดสถานะเมื่อสัญญาณไม่ชัด วิธีเหล่านี้ทำให้การทะลุหลอกกลายเป็นความผิดพลาดที่รับได้',
          'ตัวเลขที่ใช้บ่อยคือถ้าโซนกว้าง 10 Pip ให้วาง Stop Loss ไว้เลยอีกฝั่งไป 5 Pip รวมเป็น 15 Pip และลดขนาด Lot ลงครึ่งหนึ่งเมื่อกราฟยังไม่ปิดแท่งยืนยัน ผลคือถึงแม้ถูกหลอกสองครั้งติดกัน ความเสียหายรวมยังอยู่ไม่เกิน 1.5% ของพอร์ต ซึ่งยังแก้มือได้ในสัปดาห์ถัดไป',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ทะลุหลอกกับกลับตัวต่างกันอย่างไร',
        a: 'ทะลุหลอกคือราคาผ่านแนวแล้วกลับเข้าโซนเดิม ส่วนกลับตัวคือการเปลี่ยนทิศทางของโครงสร้างซึ่งมักใช้เวลานานกว่า',
        a2: 'ตัวอย่างที่แยกได้คือ ทะลุหลอกมักจบภายใน 1-3 แท่งและกลับเข้าโซนเดิม ส่วนการกลับตัวจริงต้องทำจุดสูงหรือจุดต่ำใหม่และใช้เวลาอย่างน้อย 10-20 แท่งในการสร้างโครงสร้างใหม่',
      },
      {
        q: 'มีวิธีไม่ให้เจอทะลุหลอกเลยไหม',
        a: 'ไม่มี เพราะตอนเกิดขึ้นจริงแทบแยกไม่ออก สิ่งที่ทำได้คือกำหนดความเสี่ยงให้เล็กพอที่จะรับมันได้',
        a2: 'วิธีที่ลดความเสียหายได้คือ ลดขนาดสถานะลงครึ่งหนึ่งเมื่อเข้าใกล้โซนที่เพิ่งถูกเบรก และตั้งจุดผิดห่างจากโซนอย่างน้อย 1 เท่าของ ATR กรอบเวลาที่ใช้ เพราะทะลุหลอกมักกวาดไส้เกินโซน 5-10 Pip',
      },
    ],
    related: ['support-resistance-breakout', 'support-resistance', 'forex-technical-analysis'],
  },
  {
    slug: 'rsi-indicator',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'RSI คืออะไร และอ่านค่าอย่างไร',
    description:
      'ทำความรู้จักดัชนีวัดความแข็งแรงสัมพัทธ์ ค่า 70 กับ 30 ความหมายจริง และเหตุผลที่ค่าเหล่านี้ไม่ได้บอกจุดกลับตัว',
    readingTime: '7 นาที',
    updatedDate: '2026-10-10',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20RSI%20oscillator%20panel%20teal%20line%20with%20warm%20orange%20overbought%20and%20oversold%20bands%20on%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-rsi-indicator-01&orientation=landscape',
    tags: ['RSI', 'อินดิเคเตอร์', 'โมเมนตัม'],
    intro: [
      'RSI หรือ Relative Strength Index คืออินดิเคเตอร์ที่วัดความแข็งแรงของโมเมนตัมด้วยค่าตั้งแต่ 0 ถึง 100',
      'ค่าสูงไม่ได้หมายความว่าราคาจะลงทันที และค่าต่ำก็ไม่ได้หมายความว่าจะขึ้นทันที',
    ],
    sections: [
      {
        id: 'reading',
        heading: 'อ่านค่าอย่างไร',
        paragraphs: [
          'โดยทั่วไปค่าที่เกิน 70 ถูกเรียกว่าโซนซื้อมากเกินไป และค่าที่ต่ำกว่า 30 คือขายมากเกินไป แต่คำว่าเกินไปในที่นี้หมายถึงแรงที่ต่อเนื่องมานาน ไม่ใช่ราคาที่ผิด',
        ],
        bullets: ['70 ขึ้นไป = โมเมนตัมฝั่งซื้อแรงต่อเนื่อง', 'ต่ำกว่า 30 = โมเมนตัมฝั่งขายแรงต่อเนื่อง', 'โซนกลาง 40–60 มักเป็นช่วงลังเล'],
        steps: [],
      },
      {
        id: 'trend',
        heading: 'ในตลาดแนวโน้ม ค่าจะค้าง',
        paragraphs: [
          'ตลาดขาขึ้นแรงอาจทำให้ RSI อยู่ในโซนสูงติดต่อกันหลายวัน การใช้ค่าเกิน 70 เป็นสัญญาณขายจึงทำให้ออกก่อนเวลาและพลาดแนวโน้มทั้งช่วง',
        ],
        bullets: ['ค่าในโซนสุดโต่งเป็นการยืนยันแนวโน้ม ไม่ใช่การกลับตัว', 'ควรใช้ร่วมกับโครงสร้างราคา', 'หลีกเลี่ยงการเดาจุดกลับตัวจากค่าเดียว'],
        steps: [],
      },
      {
        id: 'use',
        heading: 'ใช้ให้เกิดประโยชน์',
        paragraphs: [
          'ประโยชน์ที่สุดของ RSI คือการเห็นความคลาดเคลื่อนระหว่างราคากับโมเมนตัม และการยืนยันว่าแรงที่มากับการเคลื่อนไหวสอดคล้องกันหรือไม่',
          'การอ่านที่ได้ผลคือดู RSI บน H4 หรือ D1 มากกว่า M5 เพราะบน M5 ค่าจะแกว่งเข้าโซน 70 และ 30 บ่อยจนไม่มีความหมาย ถ้าราคาทำจุดสูงใหม่แต่ RSI ไม่ทำตาม แปลว่าแรงซื้อยังไม่มากพอที่จะยืนยันการไปต่อ ซึ่งมักเป็นสัญญาณเตือนก่อนการพักตัว 10 ถึง 20 Pip',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'RSI ตั้งค่าเท่าไรดี',
        a: 'ค่ามาตรฐานคือ 14 ซึ่งใช้กันแพร่หลายที่สุด การเปลี่ยนค่ายิ่งทำให้อินดิเคเตอร์ไวขึ้นแต่หลอกมากขึ้น',
        a2: 'ตัวเลขที่ควรรู้คือ RSI 14 จะแกว่งระหว่าง 30-70 ในตลาดปกติ และอยู่เหนือ 70 ติดกันได้ 10-20 แท่งในขาขึ้นแรง ถ้าลดค่าเป็น 7 สัญญาณจะเกิดถี่ขึ้นราว 2 เท่าแต่หลอกมากขึ้นในตลาดไซด์เวย์',
      },
      {
        q: 'RSI ใช้เดาจุดกลับตัวได้ไหม',
        a: 'ไม่ควรใช้เดี่ยว ๆ ค่าที่สุดโต่งบอกเพียงว่าแรงในฝั่งนั้นต่อเนื่องมานาน การกลับตัวต้องรอโครงสร้างราคายืนยัน',
        a2: 'ข้อควรระวังคือ RSI อาจอยู่เหนือ 70 ติดกัน 30-40 แท่งในช่วงขาขึ้นแรง ซึ่งคนที่ขายเพราะค่าเกิน 70 จะขาดทุนซ้ำ ๆ วิธีที่ใช้ได้คือรอให้โครงสร้างราคาทำ Lower High และ RSI ทำจุดสูงต่ำลงจึงค่อยพิจารณา',
      },
    ],
    related: ['technical-indicators', 'macd-indicator', 'moving-average-indicator'],
  },
  {
    slug: 'macd-indicator',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'MACD คืออะไร และใช้วิเคราะห์อย่างไร',
    description:
      'อธิบายโครงสร้าง MACD ทั้งเส้นหลัก เส้นสัญญาณ และฮิสโตแกรม พร้อมข้อควรระวังก่อนใช้สัญญาณตัดกัน',
    readingTime: '7 นาที',
    updatedDate: '2026-10-09',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20MACD%20indicator%20panel%20teal%20signal%20lines%20and%20warm%20orange%20histogram%20bars%20on%20clean%20light%20background%20editorial%20flat%20fintech%20illustration%20no%20text&width=1200&height=675&seq=art-macd-indicator-01&orientation=landscape',
    tags: ['MACD', 'อินดิเคเตอร์', 'โมเมนตัม'],
    intro: [
      'MACD ย่อมาจาก Moving Average Convergence Divergence คืออินดิเคเตอร์ที่นำเส้นค่าเฉลี่ยสองเส้นมาหาความต่าง',
      'มันแสดงทั้งทิศทางของโมเมนตัมและความแรงของมันผ่านฮิสโตแกรม',
    ],
    sections: [
      {
        id: 'parts',
        heading: 'สามส่วนของ MACD',
        paragraphs: [
          'เส้น MACD คือผลต่างของค่าเฉลี่ยสองเส้น เส้นสัญญาณคือค่าเฉลี่ยของเส้น MACD อีกที และฮิสโตแกรมคือผลต่างระหว่างสองเส้นนั้น',
        ],
        bullets: ['MACD ตัดขึ้นเส้นสัญญาณ = โมเมนตัมฝั่งซื้อเพิ่ม', 'MACD ตัดลง = โมเมนตัมฝั่งขายเพิ่ม', 'ฮิสโตแกรมหดลง = แรงเริ่มลด'],
        steps: [],
      },
      {
        id: 'limit',
        heading: 'ข้อจำกัดสำคัญ',
        paragraphs: [
          'MACD คำนวณจากค่าเฉลี่ย จึงตามราคาช้ากว่ามาก สัญญาณตัดกันที่เห็นมักเกิดหลังราคาเคลื่อนไปแล้วระยะหนึ่ง ในตลาดไซด์เวย์จะให้สัญญาณสลับไปมาไม่จบสิ้น',
        ],
        bullets: ['ใช้ยืนยัน ไม่ใช่จับจุดกลับตัว', 'หลีกเลี่ยงในตลาดไร้แนวโน้ม', 'ตรวจสอบกับโครงสร้างราคาทุกครั้ง'],
        steps: [],
      },
      {
        id: 'practical',
        heading: 'ใช้งานร่วมกับอะไร',
        paragraphs: [
          'MACD เข้ากับการอ่านแนวโน้มได้ดี เช่น ใช้ยืนยันทิศทางจาก Moving Average หรือดูว่าฮิสโตแกรมยังสนับสนุนทิศทางเดิมอยู่หรือเริ่มอ่อนลง',
          'ค่ามาตรฐาน 12 26 9 บน H4 จะตอบสนองช้ากว่า H1 ประมาณ 4 เท่า แต่สัญญาณหลอกน้อยกว่ามาก ถ้าฮิสโตแกรมเริ่มหดตัวลง 3 ถึง 4 แท่งติดกัน ขณะที่ราคายังทำจุดสูงใหม่ ให้นับเป็นสัญญาณว่าโมเมนตัมกำลังหมด ไม่ใช่สัญญาณให้สวนทางทันที',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'MACD กับ RSI ต่างกันอย่างไร',
        a: 'MACD เน้นทิศทางและความแรงของโมเมนตัม ส่วน RSI วัดว่าความแรงนั้นอยู่ในระดับใด การใช้ทั้งสองพร้อมกันมักให้ภาพที่ขัดกันเอง',
        a2: 'ตัวเลขที่ต่างชัดคือ MACD ตามราคาช้ากว่าประมาณ 5-10 แท่ง เพราะคำนวณจากเส้นค่าเฉลี่ย ส่วน RSI ตอบสนองเร็วกว่าแต่ไม่บอกทิศทาง ในทางปฏิบัติควรเลือกตัวเดียวเป็นหลัก แล้วใช้โครงสร้างราคายืนยัน',
      },
      {
        q: 'สัญญาณตัดกันของ MACD เชื่อได้ไหม',
        a: 'เชื่อได้ในระดับหนึ่งเมื่อตลาดมีแนวโน้มชัด แต่ในตลาดไซด์เวย์สัญญาณเหล่านี้ล้มเหลวบ่อยจนแทบใช้ไม่ได้',
        a2: 'ตัวเลขที่ควรรู้คือ สัญญาณตัดกันของ MACD ในตลาดไซด์เวย์ล้มเหลวราว 6-7 ใน 10 ครั้ง และแต่ละครั้งกิน 15-25 Pip ก่อนราคากลับเข้ากรอบ ควรใช้เฉพาะเมื่อราคาเบรกกรอบหรือทำจุดสูงใหม่ชัดเจน',
      },
    ],
    related: ['technical-indicators', 'rsi-indicator', 'moving-average-indicator'],
  },
  {
    slug: 'bollinger-bands',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Bollinger Bands คืออะไร',
    description:
      'เข้าใจการทำงานของ Bollinger Bands ทั้งเส้นกลางและแถบความผันผวน พร้อมวิธีอ่านการบีบตัวและการขยายตัวของแถบ',
    readingTime: '7 นาที',
    updatedDate: '2026-10-08',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20bollinger%20bands%20chart%20illustration%20teal%20price%20line%20inside%20warm%20orange%20expanding%20envelope%20bands%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-bollinger-bands-01&orientation=landscape',
    tags: ['Bollinger Bands', 'อินดิเคเตอร์', 'ความผันผวน'],
    intro: [
      'Bollinger Bands คือแถบที่วาดขึ้นจากค่าเฉลี่ยราคาและส่วนเบี่ยงเบนมาตรฐาน ทำให้เห็นระดับความผันผวนของตลาดในภาพเดียว',
      'แถบไม่ได้บอกว่าราคาแพงหรือถูก แต่บอกว่าราคาแกว่งมากหรือน้อยเมื่อเทียบกับช่วงก่อนหน้า',
    ],
    sections: [
      {
        id: 'structure',
        heading: 'โครงสร้างของแถบ',
        paragraphs: [
          'เส้นกลางคือค่าเฉลี่ยเคลื่อนที่ ส่วนแถบบนและแถบล่างคือเส้นกลางบวกและลบส่วนเบี่ยงเบนมาตรฐานตามจำนวนที่ตั้งไว้',
        ],
        bullets: ['แถบแคบ = ความผันผวนต่ำ', 'แถบกว้าง = ความผันผวนสูง', 'ราคาแตะแถบไม่ได้แปลว่ากลับตัว'],
        steps: [],
      },
      {
        id: 'squeeze',
        heading: 'การบีบตัวของแถบ',
        paragraphs: [
          'เมื่อแถบหดแคบลงมาก มักหมายถึงตลาดกำลังสะสมแรงก่อนขยายตัว แต่ทิศทางของการขยายตัวไม่สามารถรู้ได้ล่วงหน้าจากแถบ',
        ],
        bullets: ['แถบแคบไม่บอกทิศทาง', 'ควรดูระดับสำคัญประกอบ', 'การขยายตัวที่มาพร้อมแท่งใหญ่มีนัยกว่า'],
        steps: [],
      },
      {
        id: 'avoid',
        heading: 'สิ่งที่ควรระวัง',
        paragraphs: [
          'การเทรดสวนทางทุกครั้งที่ราคาแตะแถบคือกับดักที่พบบ่อย เพราะในแนวโน้มแรง ราคาสามารถเดินเลียบแถบได้เป็นช่วงยาว',
          'ประสบการณ์จริงคือในแนวโน้มขาขึ้นที่แข็งแรง ราคาอาจเดินเลียบแถบบนของ Bollinger ได้ 10 ถึง 20 แท่งติดกันบน H1 โดยไม่ยอมกลับลงมา การเปิด Sell ทุกครั้งที่แตะแถบจึงเท่ากับรับความเสี่ยงซ้ำ ๆ ในทิศทางเดียวกัน ทางที่ปลอดภัยกว่าคือรอให้ราคาหลุดเส้นกลางก่อนจึงเริ่มสนใจ',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Bollinger Bands ตั้งค่าเท่าไร',
        a: 'ค่ามาตรฐานคือระยะ 20 และส่วนเบี่ยงเบน 2 เท่า ซึ่งสมดุลระหว่างความไวและการกรองสัญญาณรบกวน',
        a2: 'ตัวเลขที่ใช้ได้คือ ระยะ 20 กับส่วนเบี่ยงเบน 2 เท่า ครอบคลุมราคาประมาณ 95% ของเวลา ถ้าลดเหลือ 1.5 เท่าแถบจะแคบลงและราคาแตะบ่อยขึ้น แต่สัญญาณก็หลอกมากขึ้นในสัดส่วนเดียวกัน',
      },
      {
        q: 'ราคาแตะแถบบนควรขายไหม',
        a: 'ไม่ควรตัดสินจากจุดเดียว การแตะแถบเป็นเพียงข้อมูลเรื่องความผันผวน ไม่ใช่สัญญาณกลับตัว',
        a2: 'วิธีที่ใช้ได้คือดูว่าแถบกำลังบีบตัวหรือขยายตัว ถ้าแถบแคบที่สุดในรอบ 20 แท่ง มักตามด้วยการเคลื่อนไหวแรงใน 5-10 แท่งถัดไป หากราคาแตะแถบแล้วปิดกลับเข้าในแถบทันที ให้ถือว่าเป็นเพียงการทดสอบ ไม่ใช่สัญญาณกลับตัว',
      },
    ],
    related: ['technical-indicators', 'rsi-indicator', 'moving-average-indicator'],
  },
];